import React from 'react';
import PropTypes from 'prop-types';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';
import { Row } from 'antd';

import DisplayText from '../../../../common/text/DisplayText';
import TableFieldColumnCard from '../TableFieldColumnCard';

function TimeEntryColumnsDragDrop({
  columns,
  onColumnDrag,
  onCustomOptionDeselect,
  configProps,
  setConfigProps,
  fieldId,
  sectionId,
  sections,
  dataType,
  divisions,
  onTitleChanged,
  validateCustomTextName,
}) {
  return (
    <DragDropContext onDragEnd={onColumnDrag}>
      <div style={{ width: '100%' }}>
        {/* Sticky columns section */}
        {columns.some(col => col.isSticky) && (
          <>
            <Row style={{ marginBottom: 10, marginTop: 10 }}>
              <DisplayText title="Sticky Columns" style={{ fontSize: '14px', fontWeight: 'bold' }} />
            </Row>
            <Droppable droppableId="sticky-columns">
              {({ droppableProps, innerRef, placeholder }) => (
                <div
                  // eslint-disable-next-line react/jsx-props-no-spreading
                  {...droppableProps}
                  ref={innerRef}
                  style={{ width: '100%', minHeight: 50 }}
                >
                  {
                    columns
                      .filter(col => col.isSticky)
                      .map((col, idx) => (
                        <TableFieldColumnCard
                          id={col.key}
                          orderIndex={idx}
                          originalName={col.originalName || col.name}
                          name={col.name}
                          isCalculation={col.isCalculation}
                          isCustomText={col.isCustomText}
                          isReadOnly={col.isReadOnly}
                          onDeleteClicked={() => { onCustomOptionDeselect(col.key); }}
                          key={col.key}
                          configProps={configProps}
                          setConfigProps={setConfigProps}
                          fieldId={fieldId}
                          sectionId={sectionId}
                          sections={sections}
                          dataType={dataType}
                          divisions={divisions}
                          onTitleChanged={onTitleChanged}
                          validateCustomTextName={validateCustomTextName}
                        />
                      ))
                  }
                  {placeholder}
                </div>
              )}
            </Droppable>
          </>
        )}

        {/* Non-sticky columns section */}
        {columns.some(col => !col.isSticky) && (
          <>
            <Row style={{ marginBottom: 10, marginTop: 15 }}>
              <DisplayText title="Regular Columns" style={{ fontSize: '14px', fontWeight: 'bold' }} />
            </Row>
            <Droppable droppableId="non-sticky-columns">
              {({ droppableProps, innerRef, placeholder }) => (
                <div
                  // eslint-disable-next-line react/jsx-props-no-spreading
                  {...droppableProps}
                  ref={innerRef}
                  style={{ width: '100%', minHeight: 50 }}
                >
                  {
                    columns
                      .filter(col => !col.isSticky)
                      .map((col, idx) => (
                        <TableFieldColumnCard
                          id={col.key}
                          orderIndex={idx}
                          originalName={col.originalName || col.name}
                          name={col.name}
                          isCalculation={col.isCalculation}
                          isCustomText={col.isCustomText}
                          isReadOnly={col.isReadOnly}
                          onDeleteClicked={() => { onCustomOptionDeselect(col.key); }}
                          key={col.key}
                          configProps={configProps}
                          setConfigProps={setConfigProps}
                          fieldId={fieldId}
                          sectionId={sectionId}
                          sections={sections}
                          dataType={dataType}
                          divisions={divisions}
                          onTitleChanged={onTitleChanged}
                          validateCustomTextName={validateCustomTextName}
                        />
                      ))
                  }
                  {placeholder}
                </div>
              )}
            </Droppable>
          </>
        )}
      </div>
    </DragDropContext>
  );
}

TimeEntryColumnsDragDrop.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string,
    name: PropTypes.string,
    originalName: PropTypes.string,
    isCalculation: PropTypes.bool,
    isReadOnly: PropTypes.bool,
    isSticky: PropTypes.bool,
  })).isRequired,
  onColumnDrag: PropTypes.func.isRequired,
  onCustomOptionDeselect: PropTypes.func.isRequired,
  configProps: PropTypes.shape({}).isRequired,
  setConfigProps: PropTypes.func.isRequired,
  fieldId: PropTypes.string.isRequired,
  sectionId: PropTypes.string.isRequired,
  sections: PropTypes.arrayOf(PropTypes.shape({})),
  dataType: PropTypes.string.isRequired,
  divisions: PropTypes.arrayOf(PropTypes.string),
  onTitleChanged: PropTypes.func.isRequired,
  validateCustomTextName: PropTypes.func,
};

TimeEntryColumnsDragDrop.defaultProps = {
  sections: [],
  divisions: undefined,
  validateCustomTextName: null,
};

export default TimeEntryColumnsDragDrop;
